import { wrap as withStyle } from 'utils/styles'
import { ssrWarning } from 'utils/emotion'
import InputLabel from 'components/patterns/Inputs/InputLabel'
import Radio from 'components/patterns/Radio'

export default withStyle(
  (props) => `
    .ant-radio-group label {
      text-align: left;
    }

    ${Radio} {
      display: ${props.horizontal ? 'inline-block' : 'block'};
      &:not(:first-child) ${ssrWarning} {
        margin-top: 5px;
      }
    }

    ${InputLabel} {
      display: block;
    }
  `
)
